<template>
  <div
    v-if="status"
    class="status-label"
    :class="size"
    :style="{ '--status-color': '#' + status.hexColor }"
  >
    {{ status.title }}
  </div>
</template>

<script>
export default {
  name: 'StatusLabel',
  props: {
    status: {
      type: Object,
      default: null
    },
    size: {
      type: String,
      default: 'normal'
    }
  }
};
</script>

<style lang="scss" scoped>
.status-label {
  display: inline-flex;
  vertical-align: middle;
  position: relative;
  font-weight: 550;
  letter-spacing: 0.015rem;
  color: var(--text);
  padding: 5px 10px 5px 20px;

  &.small {
    padding: 2px 6px 2px 18px;
    font-size: 14px;
    font-weight: 400;

    &:before {
      width: 10px;
      height: 10px;
    }
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    border-radius: 100%;
    width: 12px;
    height: 12px;
    background-color: var(--status-color);
    transform: translateY(-50%);
  }
}
</style>
